<template>
<div class="live" v-if="showVideo">
  <div v-if="liveData.status === 'live'" id="livePlayer"></div>
  <div v-if="liveData.status === 'mask'" class="mask" :style="{'background-image':`url('${liveData.mask}')`}"></div>
  <iframe v-if="liveData.status === 'playback'"
    :id="`cciframe_${liveData.vid}`"
    :src="`https://p.bokecc.com/playhtml.bo?vid=${liveData.vid}&siteid=1ECFA23CFAC24085&autoStart=false&playerid=6532F8AF7F72C091&playertype=1`"
    frameborder="0">
  </iframe>
  <template v-if="screenWidth > 768">
    <p v-if="!hasflash" class="warning-flash">
      <span>
        <p>您需要安装 Flash Player 后才能观看精彩直播～</p>
        <p>请您<a href="http://www.adobe.com/go/getflashplayer_cn">安装</a>后刷新本页面</p>
      </span>
    </p>
  </template>
</div>
</template>

<script>
import util from '../../util'

export default {
  props: ['liveData'],
  components: {
  },
  data () {
    let hasflash = util.flashCheck()
    return {
      firstplay: false,
      showVideo: false,
      hasflash,
      screenWidth: document.body.clientWidth
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.playLive()
  },
  beforeDestroy () {
  },
  methods: {
    playLive () {
      this.showVideo = true
      window.DWLive.init({
        userid: '1ECFA23CFAC24085',
        roomid: String(this.liveData.roomid)
      })
    },
    closeVideo () {
      this.showVideo = false
    }
  }
}
</script>

<style lang="sass" scoped>
=mobile
  @media screen and (max-width: 768px)
    @content
.live
  width: 539px
  height: 290px
  position: absolute
  top: 60px
  left: 0
  background: #000
  +mobile
    width: 100%
    height: 71%
    top: 15%
  #livePlayer, .mask, iframe
    width: 100%
    height: 100%
  a.close
    cursor: pointer
    position: absolute
    $size: 30px
    top: -$size/2
    right: -$size/2
    top: 0
    right: -$size
    width: $size
    height: $size
    background: #eee
    font-style: normal
    font-size: 25px
    color: #333
    display: block
    line-height: 25px
    text-align: center
    +mobile
      display: none
    &:hover
      background: #fff
.warning-flash
  width: 100%
  position: absolute
  top: 50%
  text-align: center
  color: #fff
  a
    color: red
</style>
